<template>
  <div>
    <div
      :class="isPro ? 'pro-main-title' : 'main-title'"
      v-if="needTitle"
      v-html="
        isPro
          ? $t('app.shop.basicVsProSpreadsheet.proTitle')
          : $t('app.shop.basicVsProSpreadsheet.mainTitle')
      "
    />
    <div class="item-cont">
      <div class="row no-gutters title-row">
        <div class="title-sec">
          <div
            :class="[
              'basic-title',
              needSubtitleInfo ? 'modified-basic-title' : ''
            ]"
          >
            {{ $t("app.shop.basicVsProSpreadsheet.basicColumnTitle") }}
          </div>
          <div :class="['pro-title', needSubtitleInfo ? 'with-info' : '']">
            {{ $t("app.shop.basicVsProSpreadsheet.proColumnTitle") }}
            <div v-if="needSubtitleInfo" class="pro-title-info">
              {{ $t("app.shop.basicVsProSpreadsheet.proColumnInfo") }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(reason, index) in reasonList"
        :key="'index_' + index"
        class="reason-item row no-gutters"
      >
        <item :reason="reason"></item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SpreadSheetItem from './SpreadSheetItem';

export default {
  name: 'BasicVsProSpreadSheet',
  components: {
    item: SpreadSheetItem,
  },
  props: {
    needTitle: {
      type: Boolean,
      default: true,
    },
    needSubtitleInfo: {
      type: Boolean,
      default: false,
    },
    isPro: {
      type: Boolean,
      requried: true,
    },
  },
  data() {
    return {
      reasonList: [
        {
          name: 'app.shop.basicVsProSpreadsheet.reason1',
          isBasic: true,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason2',
          isBasic: true,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason3',
          isBasic: true,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason4',
          isBasic: false,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason5',
          isBasic: false,
          isPro: true,
        },
        {
          name: `app.shop.basicVsProSpreadsheet.reason9${this.textAddition}`,
          isBasic: false,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason6',
          isBasic: false,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason7',
          isBasic: false,
          isPro: true,
        },
        {
          name: 'app.shop.basicVsProSpreadsheet.reason8',
          isBasic: false,
          isPro: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getSelectedLearnedLanguage: 'settings/getSelectedLearnedLanguage',
    }),
    textAddition() {
      if (!this.getSelectedLearnedLanguage) {
        return '';
      }
      if (this.getSelectedLearnedLanguage === 'en') {
        return '';
      }
      return `.${this.getSelectedLearnedLanguage}`;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .pro-yellow {
  color: var(--sunflower) !important;
}
.pro-main-title {
  font-family: Roboto;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
}
.main-title {
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
  padding-bottom: 58px;
}

.title-row {
  display: flex;
  justify-content: flex-end;
  .title-sec {
    width: 192px;
    display: flex;
  }
}

.item-cont {
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
  margin: 0 auto;
}
.reason-item:last-child {
  /deep/ .pro-pipe {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  /deep/ .line {
    opacity: 0;
  }
}

.basic-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: var(--white);
  width: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 19px;
}

.pro-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: var(--white);
  padding-top: 19px;
  background-color: #1b4c6e;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.pro-title-info {
  opacity: 0.7;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
  text-transform: none;
}
.with-info {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  .pro-title-info {
    padding-top: 4px;
    text-transform: none;
  }
}

.modified-basic-title {
  display: flex;
  padding-top: 10px;
  align-items: baseline;
}
</style>
